// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"435":"4a3440ce","453":"5ab90fa6","934":"620ecf3b"}[chunkId] + ".chunk.js";
};